import UserAgent from 'ua-parser-js';

// export const isMobile = () => window.screen.availWidth <= 1366;
export const isMobile = () => true;

const resize = () => {
    const device_screen = {
        width: isMobile() ? 1280 : 1920,
        height: isMobile() ? 720 : 1080
    }

    const html = document.querySelector('html');

    if(isMobile()) {
        if(!html.classList.contains('mobile')) {
            html.classList.remove('desktop');
            html.classList.add('mobile');
        }
    } else {
        if(!html.classList.contains('desktop')) {
            html.classList.remove('mobile');
            html.classList.add('desktop');
        }
    }

    const screen = {
        width: document.body.offsetWidth,
        height: document.body.offsetHeight, 
        scale: document.body.offsetWidth / device_screen.width
    }

    const rotate = document.querySelector('.rotate');

    if(screen.height > screen.width) {
        if(rotate && rotate.style.display !== 'flex')
            rotate.style.display = 'flex';
    } else {
        if(rotate && rotate.style.display !== 'none')
            rotate.style.display = 'none';
    }

    if(typeof window.old_screen !== 'undefined')
        if(window.old_screen.width === screen.width)
            return;

    window.old_screen = screen;

    const element = document.querySelector('.viewport');

    if(!element)
        return;

    const viewport = {
        width: device_screen.width * screen.scale,
        height: device_screen.height * screen.scale
    }

    if(viewport.height > screen.height) 
        screen.scale = screen.height / device_screen.height;

    element.style.transform = `scale(${screen.scale})`;
    element.style.left = `${(screen.width - device_screen.width) / 2}px`
    element.style.top = `${((screen.height - device_screen.height) / 2)}px`

    if(!window.viewPortInitialized) {
        window.viewPortInitialized = true;
        setTimeout(() => resize(), 1e3);
    }
}

const isSafari = () => {
    const agent = new UserAgent(window.navigator.userAgent),
          browser = agent.getBrowser();

    if(['Mobile Safari', 'Safari'].includes(browser.name))
        document.querySelector('body').classList.add('safari');
}

export default {
    resize,
    isSafari
}